export const TRASH_CLEAR_COMPLETE = 'TRASH_CLEAR_COMPLETE';
export const TRASH_CLEAR_START = 'TRASH_CLEAR_START';
export const TRASH_CLEAR_FAILED = 'TRASH_CLEAR_FAILED';

export const TRASH_TABS = {
    PERSONAL: 'PERSONAL',
    OTHERS: 'OTHERS',
};
